import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { toast } from "react-toastify";

import * as settingsActions from "store/entities/settingsInfo/action";

import FormDrawer from '../form-drawer';

const DeleteRoleModal = (props) => {
const {isOpen, setIsOpen, data: id, getAllRoles} = props;
const dispatch = useDispatch()
const { deleteRoleLoading, deleteRole  } = useSelector(state => state.entities.settingsInfo)


const [isDeleted, setIsDeleted] = useState(false)


const submitForm = async (e) => {
    e.preventDefault();

        dispatch(settingsActions.deleteRole(id));
        setIsDeleted(true)
        
}


useEffect(() => {
    if(deleteRole?.error === false && isDeleted ){
        getAllRoles()
        toast(deleteRole?.message)
        setIsDeleted(false)
        setIsOpen(false)
        
    }
}, [deleteRole?.error, isDeleted]);

    return (
    
    <FormDrawer display="center" size="sm" isOpen={isOpen} setIsOpen={setIsOpen}>
            <div className="p-6">
                <FormDrawer.Title
                    title="Delete Role"
                    showCloseButton={true}
                    close={setIsOpen}
                />
                
                <form onSubmit={submitForm} className='mt-4'>           
                    <div>Are you sure you want to delete this role? This action cannot be undone.</div>                           
                    <div className='bg-[#FEF5E7] text-[#101828] p-2 my-3 rounded-xl'>Please note that deleting this role will revoke the access of every employee assigned to the role.</div>
                    
                    <div className="p-1 mt-4 flex justify-end space-x-3">
                        <button type="submit" loading={deleteRoleLoading} className="btn btn-lg w-full rounded-lg whitespace-nowrap border text-white bg-ep-danger">
                            Yes
                        </button>
                        <button onClick={() => setIsOpen(false)} type="button" className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-ep-primary-600 bg-white"                    >
                            No
                        </button>
                    </div>     
                </form>
            </div>
    </FormDrawer>
  )
}

export default DeleteRoleModal